import React, { createContext, useContext, useState, useEffect } from 'react';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { getCommonVendors } from 'utils/apiRequests';
import { getFormattedSpendWithSymbol } from 'utils/number';
import { getRequiredCustomFilterObjectFormat } from 'CategoryManagement/utils';

const CommonSupplier = createContext();

const color = [
	'#032E45',
	'#012935',
	'#00212E',
	'#001A27',
	'#00131F',
	'#000C18',
	'#000511',
	'#00020A',
	'#000003',
	'#000000',
];

export const CommonSupplierProvider = ({
	children,
	currencySymbol,
	hideDecimals,
}) => {
	const [isLoading, setIsLoading] = useState(true);
	const [data, setData] = useState([]);
	const [options, setOptions] = useState({
		colorAxis: {
			minColor: '#FFFFFF',
			maxColor: '#032E45',
		},
		chart: {
			type: 'heatmap',
			height: '30%',
		},
		title: { text: '' },
		exporting: { enabled: false, allowHTML: true },
		credits: { enabled: false },
		legend: {
			align: 'right',
			verticalAlign: 'middle',
			layout: 'vertical',
			// symbolRadius: 1,
			symbolHeight: 140,
			// useHTML: true,
			itemMarginBottom: 50,
			formatter: function() {
				return getFormattedSpendWithSymbol(
					this.value,
					currencySymbol,
					hideDecimals
				).toUpperCase();
			},
			// itemStyle: {
			// 	...FONTSTYLE,
			// 	textOverflow: 'ellipsis',
			// },
		},
		tooltip: {
			enabled: true,
			shared: true,
			distance: 56,
			useHTML: true,
			backgroundColor: 'rgba(255,255,255, 0.9)',
			borderWidth: 0,
			outside: true,
			borderRadius: 2,
		},
		// series: [],
		colors: color,
	});

	const {
		currentSelectCategory,
		dateRangeData,
		isFetching,
		isDirect,
		isSourceable,
		taxonomyType,
		customFilters,
		customFiltersValues,
	} = useContext(CategoryManagementContext);
	const { loading: isSettingsFetching } = useContext(
		CategoryInsightsSettingsContext
	);
	const { categoryName } = currentSelectCategory;
	const { dateFrom, dateTo } = dateRangeData;

	useEffect(
		() => {
			if (!isSettingsFetching && !isFetching) {
				setIsLoading(true);
				if (
					categoryName !== '' ||
					categoryName !== null ||
					categoryName !== undefined
				) {
					const payload = {
						categoryName: categoryName,
						dateFrom: dateFrom,
						dateTo: dateTo,
						isSourceable: isSourceable,
						aptaxonomy: isDirect,
						taxonomyType: taxonomyType,
					};
					if (
						Array.isArray(customFiltersValues) &&
						customFiltersValues.length > 0
					) {
						payload.customfilter = getRequiredCustomFilterObjectFormat(
							customFilters,
							customFiltersValues
						);
					}
					getCommonVendors(payload)
						.then(response => {
							if (response.data.length > 0) {
								setData(response);
								const topVendors = response.data.sort((a, b) => b.vendorSpend);
								// .slice(0, 10);
								const uniqueCommonVendors = [
									...new Set(
										topVendors.map(datapoint => datapoint.commonVendors)
									),
								];
								const uniqueBU = [
									...new Set(
										topVendors.map(datapoint => datapoint.businessUnits)
									),
								];
								const seriesData = response.data.map(category => {
									return {
										x: uniqueBU.indexOf(category.businessUnits),
										y: uniqueCommonVendors.indexOf(category.commonVendors),
										value: category.vendorSpend,
										colorValue: category.vendorSpend,
									};
								});
								const seriesResult = [
									{
										data: seriesData,
									},
								];

								setOptions(prevState => ({
									...prevState,
									series: seriesResult,
									// tooltip: {
									// 	...prevState.tooltip,
									// 	formatter: function() {
									// 		const { points } = this;
									// 		return response.length > 1
									// 			? renderToString(
									// 					<TooltipWrapper>
									// 						<TooltipGrid>
									// 							<React.Fragment key={this.point?.name}>
									// 								<ColorWrapper>
									// 									<ColorSymbol color={this.color} />
									// 								</ColorWrapper>
									// 								<TooltipRowTitle>
									// 									{this.point?.name}
									// 								</TooltipRowTitle>
									// 								<TooltipRowValue>
									// 									{getFormattedSpendWithSymbol(
									// 										this.point.value,
									// 										currencySymbol,
									// 										hideDecimals
									// 									).toUpperCase()}
									// 								</TooltipRowValue>
									// 							</React.Fragment>
									// 						</TooltipGrid>
									// 					</TooltipWrapper>
									// 			  )
									// 			: renderToString(
									// 					<TooltipWrapper>
									// 						<TooltipGrid>
									// 							<ColorWrapper>
									// 								<ColorSymbol color={points[0].color} />
									// 							</ColorWrapper>
									// 							<TooltipRowValue>
									// 								{getFormattedSpendWithSymbol(
									// 									points[0].y,
									// 									currencySymbol,
									// 									hideDecimals
									// 								).toUpperCase()}
									// 							</TooltipRowValue>
									// 						</TooltipGrid>
									// 					</TooltipWrapper>
									// 			  );
									// 	},
									// },
									xAxis: {
										title: {
											enabled: true,
											text: 'BU',
										},
										categories: uniqueBU,
									},

									yAxis: {
										title: {
											enabled: true,
											text: 'vendor',
										},
										categories: uniqueCommonVendors,
									},
								}));
								setIsLoading(false);
							} else {
								setIsLoading(false);
							}
						})
						.catch(() => setIsLoading(false));
				} else {
					setIsLoading(false);
				}
			}
		}, // eslint-disable-next-line
		[
			dateRangeData,
			categoryName,
			isSettingsFetching,
			isFetching,
			isDirect,
			isSourceable,
			taxonomyType,
			customFilters,
			customFiltersValues,
		]
	);

	return (
		<CommonSupplier.Provider value={{ isLoading, data, options }}>
			{children}
		</CommonSupplier.Provider>
	);
};

export const useCommonSuppliersContext = () => {
	return useContext(CommonSupplier);
};
// export default CommonSupplierProvider;
